/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-log-label-and-btn',
    templateUrl: './log-label-and-btn.component.html',
    styleUrls: ['../export/export.component.scss'],
})
export class LogLabelAndBtnComponent {
    /**
     * 要导出的日志名称
     */
    @Input() logLabel: string;
    /**
     * 日志名称后的问号提示
     */
    @Input() helpContent: string;
    /**
     * 问号提示隐藏条件
     */
    @Input() helpIconHidden: boolean;
    /**
     * 导出按钮的ID
     */
    @Input() btnId: string;
    /**
     * 导出按钮的名称
     */
    @Input() btnLabel: string;
    /**
     * 导出按钮的禁用状态
     */
    @Input() btnDisabled: boolean;
    /**
     * 导出按钮的禁用提示
     */
    @Input() btnDisabledTip: string;
    /**
     * 导出按钮是否显示加载中
     */
    @Input() btnLoading: boolean;

    /**
     * 导出按钮被点击
     */
    @Output() clickBtn = new EventEmitter<void>();

    btnClicked(): void {
        this.clickBtn.emit();
    }
}
